#@export swfobject
#  SWFObject v2.2 <http://code.google.com/p/swfobject/> 
#  is released under the MIT License <http://www.opensource.org/licenses/mit-license.php> 


window.swfobject = (->

  UNDEF = "undefined"
  OBJECT = "object"
  SHOCKWAVE_FLASH = "Shockwave Flash"
  SHOCKWAVE_FLASH_AX = "ShockwaveFlash.ShockwaveFlash"
  FLASH_MIME_TYPE = "application/x-shockwave-flash"
  EXPRESS_INSTALL_ID = "SWFObjectExprInst"
  ON_READY_STATE_CHANGE = "onreadystatechange"
    
  win = window
  doc = document
  nav = navigator
    
  plugin = false
  regObjArr = []
  objIdArr = []
  listenersArr = []
  isDomLoaded = false
  isExpressInstallActive = false
  autoHideShow = true
  storedAltContent = storedAltContentId = storedCallbackFn = storedCallbackObj = dynamicStylesheet = dynamicStylesheetMedia = null

  callDomLoadFunctions = ->
    return if isDomLoaded

    try # test if we can really add/remove elements to/from the DOM; we don't want to fire it too early
      t = doc.getElementsByTagName("body")[0].appendChild(createElement("span"))
      t.parentNode.removeChild(t)

    catch e
      return

    isDomLoaded = true
    dl = domLoadFnArr

    for dlFn, i in domLoadFnArr or []
      dlFn()

  addDomLoadEvent = (fn) ->
    if isDomLoaded
      fn()

    else
      domLoadFnArr[domLoadFnArr.length] = fn # Array.push() is only available in IE5.5+


  # Cross-browser onload
  #  - Based on James Edwards' solution: http://brothercake.com/site/resources/scripts/onload/
  #  - Will fire an event as soon as a web page including all of its assets are loaded 

  addLoadEvent = (fn) ->
    if (typeof win.addEventListener != UNDEF)
      win.addEventListener("load", fn, false)

    else if (typeof doc.addEventListener != UNDEF)
      doc.addEventListener("load", fn, false)

    else if (typeof win.attachEvent != UNDEF)
      addListener(win, "onload", fn)

    else if (typeof win.onload == "function")
      fnOld = win.onload
      win.onload = ->
        fnOld()
        fn()

    else
      win.onload = fn


  # Main function
  #  - Will preferably execute onDomLoad, otherwise onload (as a fallback)

  main = ->
    if (plugin)
      testPlayerVersion()

    else
      matchVersions()

  domLoadFnArr = [main]

  # Detect the Flash Player version for non-Internet Explorer browsers
  #  - Detecting the plug-in version via the object element is more precise than using the plugins collection item's description:
  #    a. Both release and build numbers can be detected
  #    b. Avoid wrong descriptions by corrupt installers provided by Adobe
  #    c. Avoid wrong descriptions by multiple Flash Player entries in the plugin Array, caused by incorrect browser imports
  #  - Disadvantage of this method is that it depends on the availability of the DOM, while the plugins collection is immediately available

  testPlayerVersion = ->
    b = doc.getElementsByTagName("body")[0]
    o = createElement(OBJECT)
    o.setAttribute("type", FLASH_MIME_TYPE)
    t = b.appendChild(o)
    if (t)
      counter = 0
      (->
        if (typeof t.GetVariable != UNDEF)
          d = t.GetVariable("$version")
          if (d)
            d = d.split(" ")[1].split(",")
            ua.pv = [parseInt(d[0], 10), parseInt(d[1], 10), parseInt(d[2], 10)]

        else if (counter < 10)
          counter++
          setTimeout(arguments.callee, 10)
          return

        b.removeChild(o)
        t = null
        matchVersions()
      )()

    else
      matchVersions()


  # Perform Flash Player and SWF version matching; static publishing only

  matchVersions = ->
    rl = regObjArr.length
    if regObjArr.length
      for regObj, i in regObjArr # for each registered object element
        id = regObj.id
        cb = regObj.callbackFn
        cbObj = {success:false, id:id}

        if ua.pv[0] > 0
          obj = getElementById(id)

          if obj
            if hasPlayerVersion(regObj.swfVersion) && !(ua.wk && ua.wk < 312) # Flash Player version >= published SWF version: Houston, we have a match!
              setVisibility(id, true)

              if cb
                cbObj.success = true
                cbObj.ref = getObjectById(id)
                cb(cbObj)

            else if regObj.expressInstall && canExpressInstall() # show the Adobe Express Install dialog if set by the web page author and if supported
              att = {}
              att.data = regObj.expressInstall
              att.width = obj.getAttribute("width") || "0"
              att.height = obj.getAttribute("height") || "0"

              if obj.getAttribute("class")
                att.styleclass = obj.getAttribute("class")

              if obj.getAttribute("align")
                att.align = obj.getAttribute("align")

              # parse HTML object param element's name-value pairs
              par = {}
              p = obj.getElementsByTagName("param")
              pl = p.length

              for pair in p or []
                if pair.getAttribute("name").toLowerCase() != "movie"
                  par[pair.getAttribute("name")] = pair.getAttribute("value")

              showExpressInstall(att, par, id, cb)

            else # Flash Player and SWF version mismatch or an older Webkit engine that ignores the HTML object element's nested param elements: display alternative content instead of SWF
              displayAltContent(obj)

              if cb
                cb(cbObj)

        else  # if no Flash Player is installed or the fp version cannot be detected we let the HTML object element do its job (either show a SWF or alternative content)
          setVisibility(id, true)
          if (cb)
            o = getObjectById(id); # test whether there is an HTML object element or not
            if (o && typeof o.SetVariable != UNDEF)
              cbObj.success = true
              cbObj.ref = o

            cb(cbObj)

  getObjectById = (objectIdStr) ->
    r = null
    o = getElementById(objectIdStr)
    if (o && o.nodeName == "OBJECT")
      if (typeof o.SetVariable != UNDEF)
        r = o

      else
        n = o.getElementsByTagName(OBJECT)[0]
        if (n)
          r = n

    return r

  # Requirements for Adobe Express Install
  #  - only one instance can be active at a time
  #  - fp 6.0.65 or higher
  #  - Win/Mac OS only
  #  - no Webkit engines older than version 312

  canExpressInstall = ->
    return !isExpressInstallActive && hasPlayerVersion("6.0.65") && (ua.win || ua.mac) && !(ua.wk && ua.wk < 312)

  # Show the Adobe Express Install dialog
  #  - Reference: http://www.adobe.com/cfusion/knowledgebase/index.cfm?id=6a253b75

  showExpressInstall = (att, par, replaceElemIdStr, callbackFn) ->
    isExpressInstallActive = true
    storedCallbackFn = callbackFn || null
    storedCallbackObj = {success:false, id:replaceElemIdStr}
    obj = getElementById(replaceElemIdStr)

    if obj
      if obj.nodeName == "OBJECT" # static publishing
        storedAltContent = abstractAltContent(obj)
        storedAltContentId = null

      else # dynamic publishing
        storedAltContent = obj
        storedAltContentId = replaceElemIdStr

      att.id = EXPRESS_INSTALL_ID

      if typeof att.width == UNDEF || (!/%$/.test(att.width) && parseInt(att.width, 10) < 310)
        att.width = "310"

      if typeof att.height == UNDEF || (!/%$/.test(att.height) && parseInt(att.height, 10) < 137)
        att.height = "137"

      doc.title = doc.title.slice(0, 47) + " - Flash Player Installation"
      pt = if ua.ie && ua.win then "ActiveX" else "PlugIn"
      fv = "MMredirectURL=" + win.location.toString().replace(/&/g,"%26") + "&MMplayerType=" + pt + "&MMdoctitle=" + doc.title

      if typeof par.flashvars != UNDEF
        par.flashvars += "&" + fv

      else
        par.flashvars = fv

      # IE only: when a SWF is loading (AND: not available in cache) wait for the readyState of the object element to become 4 before removing it,
      # because you cannot properly cancel a loading SWF file without breaking browser load references, also obj.onreadystatechange doesn't work
      if (ua.ie && ua.win && obj.readyState != 4)
        newObj = createElement("div")
        replaceElemIdStr += "SWFObjectNew"
        newObj.setAttribute("id", replaceElemIdStr)
        obj.parentNode.insertBefore(newObj, obj); # insert placeholder div that will be replaced by the object element that loads expressinstall.swf
        obj.style.display = "none"
        (->
          if (obj.readyState == 4)
            obj.parentNode.removeChild(obj)

          else
            setTimeout(arguments.callee, 10)

        )()

      createSWF(att, par, replaceElemIdStr)



  # Functions to abstract and display alternative content

  displayAltContent = (obj) ->
    if (ua.ie && ua.win && obj.readyState != 4)
      # IE only: when a SWF is loading (AND: not available in cache) wait for the readyState of the object element to become 4 before removing it,
      # because you cannot properly cancel a loading SWF file without breaking browser load references, also obj.onreadystatechange doesn't work
      el = createElement("div")
      obj.parentNode.insertBefore(el, obj); # insert placeholder div that will be replaced by the alternative content
      el.parentNode.replaceChild(abstractAltContent(obj), el)
      obj.style.display = "none"
      (->
        if obj.readyState == 4
          obj.parentNode.removeChild(obj)

        else
          setTimeout(arguments.callee, 10)
      )()

    else
      obj.parentNode.replaceChild(abstractAltContent(obj), obj)


  abstractAltContent = (obj) ->
    ac = createElement("div")

    if ua.win && ua.ie
      ac.innerHTML = obj.innerHTML

    else
      nestedObj = obj.getElementsByTagName(OBJECT)[0]

      if nestedObj
        c = nestedObj.childNodes

        if c
          cl = c.length

          for childNode in c
            if !(childNode.nodeType == 1 && childNode.nodeName == "PARAM") && !(childNode.nodeType == 8)
              ac.appendChild(childNode.cloneNode(true))

    return ac


  # Cross-browser dynamic SWF creation

  createSWF = (attObj, parObj, id) ->
    r = undefined
    el = getElementById(id)
    return r if ua.wk && ua.wk < 312

    if el
      if typeof attObj.id == UNDEF # if no 'id' is defined for the object element, it will inherit the 'id' from the alternative content
        attObj.id = id

      if (ua.ie && ua.win) # Internet Explorer + the HTML object element + W3C DOM methods do not combine: fall back to outerHTML
        att = ""

        for i of attObj
          if (attObj[i] != Object.prototype[i]) # filter out prototype additions from other potential libraries
            if (i.toLowerCase() == "data")
              parObj.movie = attObj[i]

            else if (i.toLowerCase() == "styleclass") # 'class' is an ECMA4 reserved keyword
              att += ' class="' + attObj[i] + '"'

            else if (i.toLowerCase() != "classid")
              att += ' ' + i + '="' + attObj[i] + '"'

        par = ""

        for j of parObj
          if (parObj[j] != Object.prototype[j]) # filter out prototype additions from other potential libraries
            par += '<param name="' + j + '" value="' + parObj[j] + '" />'

        el.outerHTML = '<object classid="clsid:D27CDB6E-AE6D-11cf-96B8-444553540000"' + att + '>' + par + '</object>'
        objIdArr[objIdArr.length] = attObj.id; # stored to fix object 'leaks' on unload (dynamic publishing only)
        r = getElementById(attObj.id)

      else # well-behaving browsers
        o = createElement(OBJECT)
        o.setAttribute("type", FLASH_MIME_TYPE)

        for m of attObj
          if (attObj[m] != Object.prototype[m]) # filter out prototype additions from other potential libraries
            if (m.toLowerCase() == "styleclass") # 'class' is an ECMA4 reserved keyword
              o.setAttribute("class", attObj[m])

            else if (m.toLowerCase() != "classid") # filter out IE specific attribute
              o.setAttribute(m, attObj[m])

        for n of parObj
          if (parObj[n] != Object.prototype[n] && n.toLowerCase() != "movie") # filter out prototype additions from other potential libraries and IE specific param element
            createObjParam(o, n, parObj[n])

        el.parentNode.replaceChild(o, el)
        r = o

    return r


  createObjParam = (el, pName, pValue) ->
    p = createElement("param")
    p.setAttribute("name", pName)
    p.setAttribute("value", pValue)
    el.appendChild(p)


  # Cross-browser SWF removal
  #  - Especially needed to safely and completely remove a SWF in Internet Explorer

  removeSWF = (id) ->
    obj = getElementById(id)
    if (obj && obj.nodeName == "OBJECT")
      if (ua.ie && ua.win)
        obj.style.display = "none"
        (->
          if (obj.readyState == 4)
            removeObjectInIE(id)

          else
            setTimeout(arguments.callee, 10)
        )()

      else
        obj.parentNode.removeChild(obj)


  removeObjectInIE = (id) ->
    obj = getElementById(id)
    if (obj)
      for thing in obj
        if (typeof thing == "function")
          thing = null

      obj.parentNode.removeChild(obj)


  # Functions to optimize JavaScript compression

  getElementById = (id) ->
    el = null
    try
      el = doc.getElementById(id)

    catch e
      # no-op

    return el


  createElement = (el) ->
    return doc.createElement(el)


  # Updated attachEvent function for Internet Explorer
  #  - Stores attachEvent information in an Array, so on unload the detachEvent functions can be called to avoid memory leaks

  addListener = (target, eventType, fn) ->
    target.attachEvent(eventType, fn)
    listenersArr[listenersArr.length] = [target, eventType, fn]


  # Flash Player and SWF content version matching

  hasPlayerVersion = (rv) ->
    pv = ua.pv
    v = rv.split(".")
    v[0] = parseInt(v[0], 10)
    v[1] = parseInt(v[1], 10) || 0; # supports short notation, e.g. "9" instead of "9.0.0"
    v[2] = parseInt(v[2], 10) || 0
    return (pv[0] > v[0] || (pv[0] == v[0] && pv[1] > v[1]) || (pv[0] == v[0] && pv[1] == v[1] && pv[2] >= v[2])) ? true : false


  # Cross-browser dynamic CSS creation
  #  - Based on Bobby van der Sluis' solution: http://www.bobbyvandersluis.com/articles/dynamicCSS.php

  createCSS = (sel, decl, media, newStyle) ->
    return if ua.ie && ua.mac
    h = doc.getElementsByTagName("head")[0]
    return unless h # to also support badly authored HTML pages that lack a head element
    m = (media && typeof media == "string") ? media : "screen"

    if newStyle
      dynamicStylesheet = null
      dynamicStylesheetMedia = null

    if !dynamicStylesheet || dynamicStylesheetMedia != m
      # create dynamic stylesheet + get a global reference to it
      s = createElement("style")
      s.setAttribute("type", "text/css")
      s.setAttribute("media", m)
      dynamicStylesheet = h.appendChild(s)

      if (ua.ie && ua.win && typeof doc.styleSheets != UNDEF && doc.styleSheets.length > 0)
        dynamicStylesheet = doc.styleSheets[doc.styleSheets.length - 1]

      dynamicStylesheetMedia = m

    # add style rule
    if ua.ie && ua.win
      if dynamicStylesheet && typeof dynamicStylesheet.addRule == OBJECT
        dynamicStylesheet.addRule(sel, decl)

    else
      if dynamicStylesheet && typeof doc.createTextNode != UNDEF
        dynamicStylesheet.appendChild(doc.createTextNode(sel + " {" + decl + "}"))


  setVisibility = (id, isVisible) ->
    return unless autoHideShow
    v = isVisible ? "visible" : "hidden"

    if isDomLoaded && getElementById(id)
      getElementById(id).style.visibility = v

    else
      createCSS("#" + id, "visibility:" + v)


  # Filter to avoid XSS attacks

  urlEncodeIfNecessary = (s) ->
    regex = /[\\\"<>\.;]/
    hasBadChars = regex.exec(s) != null
    return hasBadChars && typeof encodeURIComponent !=  if UNDEF then encodeURIComponent(s) else s


  # Centralized function for browser feature detection
  #  - User agent string detection is only used when no good alternative is possible
  #  - Is executed directly for optimal performance

  ua = (->
    w3cdom = typeof doc.getElementById != UNDEF && typeof doc.getElementsByTagName != UNDEF && typeof doc.createElement != UNDEF
    u = nav.userAgent.toLowerCase()
    p = nav.platform.toLowerCase()
    windows = if p then /win/.test(p) else /win/.test(u)
    mac = if p then /mac/.test(p) else /mac/.test(u)
    webkit = if /webkit/.test(u) then parseFloat(u.replace(/^.*webkit\/(\d+(\.\d+)?).*$/, "$1")) else false # returns either the webkit version or false if not webkit
    ie = !+"\v1" # feature detection based on Andrea Giammarchi's solution: http://webreflection.blogspot.com/2009/01/32-bytes-to-know-if-your-browser-is-ie.html
    playerVersion = [0,0,0]
    d = null

    if typeof nav.plugins != UNDEF && typeof nav.plugins[SHOCKWAVE_FLASH] == OBJECT
      d = nav.plugins[SHOCKWAVE_FLASH].description

      if d && !(typeof nav.mimeTypes != UNDEF && nav.mimeTypes[FLASH_MIME_TYPE] && !nav.mimeTypes[FLASH_MIME_TYPE].enabledPlugin) # navigator.mimeTypes["application/x-shockwave-flash"].enabledPlugin indicates whether plug-ins are enabled or disabled in Safari 3+
        plugin = true
        ie = false # cascaded feature detection for Internet Explorer
        d = d.replace(/^.*\s+(\S+\s+\S+$)/, "$1")
        playerVersion[0] = parseInt(d.replace(/^(.*)\..*$/, "$1"), 10)
        playerVersion[1] = parseInt(d.replace(/^.*\.(.*)\s.*$/, "$1"), 10)
        playerVersion[2] = if /[a-zA-Z]/.test(d) then parseInt(d.replace(/^.*[a-zA-Z]+(.*)$/, "$1"), 10) else 0


    else if typeof win.ActiveXObject != UNDEF
      try
        a = new ActiveXObject(SHOCKWAVE_FLASH_AX)

        if a # a will return null when ActiveX is disabled
          d = a.GetVariable("$version")

          if d
            ie = true # cascaded feature detection for Internet Explorer
            d = d.split(" ")[1].split(",")
            playerVersion = [parseInt(d[0], 10), parseInt(d[1], 10), parseInt(d[2], 10)]

      catch e
        # no-op

    return { w3:w3cdom, pv:playerVersion, wk:webkit, ie:ie, win:windows, mac:mac }
  )()


  # Cross-browser onDomLoad
  #  - Will fire an event as soon as the DOM of a web page is loaded
  #  - Internet Explorer workaround based on Diego Perini's solution: http://javascript.nwbox.com/IEContentLoaded/
  #  - Regular onload serves as fallback

  onDomLoad = (->
    return unless ua.w3
    if (typeof doc.readyState != UNDEF && doc.readyState == "complete") || (typeof doc.readyState == UNDEF && (doc.getElementsByTagName("body")[0] || doc.body)) # function is fired after onload, e.g. when script is inserted dynamically 
      callDomLoadFunctions()

    if !isDomLoaded
      if typeof doc.addEventListener != UNDEF
        doc.addEventListener("DOMContentLoaded", callDomLoadFunctions, false)

      if ua.ie && ua.win
        doc.attachEvent ON_READY_STATE_CHANGE, ->
          if doc.readyState == "complete"
            doc.detachEvent(ON_READY_STATE_CHANGE, arguments.callee)
            callDomLoadFunctions()

        if win == top # if not inside an iframe
          (->
            return if isDomLoaded

            try
              doc.documentElement.doScroll("left")

            catch e
              setTimeout(arguments.callee, 0)
              return

            callDomLoadFunctions()
          )()

      if ua.wk
        (->
          return if isDomLoaded

          if !/loaded|complete/.test(doc.readyState)
            setTimeout(arguments.callee, 0)
            return

          callDomLoadFunctions()
        )()

      addLoadEvent(callDomLoadFunctions)
  )()


# Release memory to avoid memory leaks caused by closures, fix hanging audio/video threads and force open sockets/NetConnections to disconnect (Internet Explorer only)

  cleanup = (->
    if (ua.ie && ua.win)
      window.attachEvent "onunload", ->
        # remove listeners to avoid memory leaks
        for listener in listenersArr
          listener[0].detachEvent(listener[1], listener[2])

        # cleanup dynamically embedded objects to fix audio/video threads and force open sockets and NetConnections to disconnect
        for obj in objIdArr
          removeSWF(obj)

        # cleanup library's main closures to avoid memory leaks
        for k of ua
          ua[k] = null

        ua = null
        for l of swfobject
          swfobject[l] = null

        swfobject = null
  )()

# Public API
#  - Reference: http://code.google.com/p/swfobject/wiki/documentation
  return {
    registerObject: (objectIdStr, swfVersionStr, xiSwfUrlStr, callbackFn) ->
      if ua.w3 && objectIdStr && swfVersionStr
        regObj = {}
        regObj.id = objectIdStr
        regObj.swfVersion = swfVersionStr
        regObj.expressInstall = xiSwfUrlStr
        regObj.callbackFn = callbackFn
        regObjArr[regObjArr.length] = regObj
        setVisibility(objectIdStr, false)

      else
        callbackFn?({success:false, id:objectIdStr})
    
    getObjectById: (objectIdStr) ->
      if ua.w3
        return getObjectById(objectIdStr)
    
    embedSWF: (swfUrlStr, replaceElemIdStr, widthStr, heightStr, swfVersionStr, xiSwfUrlStr, flashvarsObj, parObj, attObj, callbackFn) ->
      callbackObj = {success:false, id:replaceElemIdStr}

      if ua.w3 && !(ua.wk && ua.wk < 312) && swfUrlStr && replaceElemIdStr && widthStr && heightStr && swfVersionStr
        setVisibility(replaceElemIdStr, false)
        addDomLoadEvent ->
          widthStr += ""; # auto-convert to string
          heightStr += ""
          att = {}

          if attObj && typeof attObj == OBJECT
            for i of attObj # copy object to avoid the use of references, because web authors often reuse attObj for multiple SWFs
              att[i] = attObj[i]

          att.data = swfUrlStr
          att.width = widthStr
          att.height = heightStr
          par = {}

          if parObj && typeof parObj == OBJECT
            for j of parObj # copy object to avoid the use of references, because web authors often reuse parObj for multiple SWFs
              par[j] = parObj[j]

          if flashvarsObj && typeof flashvarsObj == OBJECT
            for k of flashvarsObj # copy object to avoid the use of references, because web authors often reuse flashvarsObj for multiple SWFs
              if typeof par.flashvars != UNDEF
                par.flashvars += "&" + k + "=" + flashvarsObj[k]

              else
                par.flashvars = k + "=" + flashvarsObj[k]

          if hasPlayerVersion(swfVersionStr) # create SWF
            obj = createSWF(att, par, replaceElemIdStr)

            if att.id == replaceElemIdStr
              setVisibility(replaceElemIdStr, true)

            callbackObj.success = true
            callbackObj.ref = obj

          else if xiSwfUrlStr && canExpressInstall() # show Adobe Express Install
            att.data = xiSwfUrlStr
            showExpressInstall(att, par, replaceElemIdStr, callbackFn)
            return

          else # show alternative content
            setVisibility(replaceElemIdStr, true)

          callbackFn?(callbackObj)

      else
        callbackFn?(callbackObj)

    switchOffAutoHideShow: ->
      autoHideShow = false

    ua: ua

    getFlashPlayerVersion: ->
      return { major:ua.pv[0], minor:ua.pv[1], release:ua.pv[2] }

    hasFlashPlayerVersion: hasPlayerVersion

    createSWF: (attObj, parObj, replaceElemIdStr) ->
      if ua.w3
        return createSWF(attObj, parObj, replaceElemIdStr)

      else
        return undefined

    showExpressInstall: (att, par, replaceElemIdStr, callbackFn) ->
      if ua.w3 && canExpressInstall()
        showExpressInstall(att, par, replaceElemIdStr, callbackFn)

    removeSWF: (objElemIdStr) ->
      if ua.w3
        removeSWF(objElemIdStr)

    createCSS: (selStr, declStr, mediaStr, newStyleBoolean) ->
      if ua.w3
        createCSS(selStr, declStr, mediaStr, newStyleBoolean)

    addDomLoadEvent: addDomLoadEvent
    addLoadEvent: addLoadEvent

    getQueryParamValue: (param) ->
      q = doc.location.search || doc.location.hash

      if (q)
        if /\?/.test(q)
          q = q.split("?")[1] # strip question mark

        if param == null
          return urlEncodeIfNecessary(q)

        pairs = q.split("&")

        for pair in pairs
          if pair.substring(0, pair.indexOf("=")) == param
            return urlEncodeIfNecessary pair.substring (pair.indexOf("=") + 1)

      return ""

    # For internal usage only
    expressInstallCallback: ->
      if isExpressInstallActive
        obj = getElementById(EXPRESS_INSTALL_ID)

        if obj && storedAltContent
          obj.parentNode.replaceChild(storedAltContent, obj)

          if storedAltContentId
            setVisibility(storedAltContentId, true)

            if ua.ie && ua.win
              storedAltContent.style.display = "block"

          if storedCallbackFn
            storedCallbackFn(storedCallbackObj)

        isExpressInstallActive = false
  }
)()
